export default "__VITE_ASSET__CEbLdvOu__"